import { MODEL_PORTFOLIO } from 'NewAngular/constants/core.constants';
import { ReportNamingConvention } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/enums/naming-convention.enum';
export class NamingConventionService {
    static reportLabel(security, namingConvention, securityIDX) {
        if (security.securityId == null ||
            security.securityName == null ||
            security.displaySecurityID == null ||
            security.securityType == null)
            return '';
        switch (namingConvention) {
            case ReportNamingConvention.TRUNCATED:
                return security.securityName;
            case ReportNamingConvention.TICKER:
                return security.displaySecurityID;
            case ReportNamingConvention.LETTERING:
                const label = security.securityType === MODEL_PORTFOLIO ? 'Portfolio' : 'Security';
                return `${label} ${String.fromCharCode(securityIDX + 65)}`;
            case ReportNamingConvention.CUSTOM:
                return security.customLabel || '';
            default:
                throw new Error('Unrecognized naming convention');
        }
    }
}
